const API_BASE = '_api/v2.0';
export const API_DRIVE_BASE = `${API_BASE}/drive`;

export const API_BASE_FOR_SHARES = `${API_BASE}/shares`;

export const API_BASE_FOR_PATH = `${API_DRIVE_BASE}/root`;
export const API_BASE_FOR_ID = `${API_DRIVE_BASE}/items`;

export const ROOT_FOLDER_ID = 'root';

export const ONE_DRIVE_CONUSMER_API_URL = 'https://s2s-api.onedrive.com';

// 10MB. One drive recommends that the slize size should be 5-10MB and it should be multiple
// of 320 KB.
export const DEFAULT_UPLOAD_SLICE_SIZE = 10 * 1024 * 1024;
